/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { className, attributes } = props;
	const { blockClientId } = attributes;

	const wrapperClasses = classnames(
		className,
		'gutenify-block-slide-item-wrapper',
		'swiper-slide',
		`gutenify-section-${ blockClientId }`,
	);

	return (
		<div className={ wrapperClasses }>
			<InnerBlocks.Content />
		</div>

	);
}

